import { render, staticRenderFns } from "./ProductStats.vue?vue&type=template&id=7b420e68&scoped=true&"
import script from "./ProductStats.vue?vue&type=script&lang=js&"
export * from "./ProductStats.vue?vue&type=script&lang=js&"
import style0 from "./ProductStats.vue?vue&type=style&index=0&id=7b420e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b420e68",
  null
  
)

export default component.exports